<kendo-listview
        [itemStyle]="itemStyle"
        [data]="gridData"
    >
      <ng-template kendoListViewHeaderTemplate>

      </ng-template>
      <ng-template
        kendoListViewItemTemplate
        let-dataItem="dataItem"
      >
      
        <app-drake-custom-component [config]="subComponent" [baseData]="dataItem" [readonly]="false" *ngIf="subComponent" style="width: 100%;"></app-drake-custom-component>
      </ng-template>
      <ng-template kendoListViewFooterTemplate>
      </ng-template>
    </kendo-listview>
 